// extracted by mini-css-extract-plugin
module.exports = {"editor":"NoteTextEditor_editor__3DDsy","white":"NoteTextEditor_white__1i9mS"};